import { AlarmsActionType, AlarmsContext } from '@core/context';
import { AlarmsAcknowledgeType, AlarmsFilterOptionsModel } from '@shared/models';
import { useCallback, useContext } from 'react';

export const useAlarmsFilterState = () => {
  const { state: alarmsState, dispatch: alarmsDispatch } = useContext(AlarmsContext);

  const setConditionFilter = useCallback(
    (payload: string) => {
      alarmsDispatch({ type: AlarmsActionType.SetCondition, payload });
    },
    [alarmsDispatch]
  );

  const setAcknowledgeFilter = useCallback(
    (payload: AlarmsAcknowledgeType) => {
      alarmsDispatch({ type: AlarmsActionType.SetAcknowledge, payload });
    },
    [alarmsDispatch]
  );

  const setShowSystemAlarmsFilter = useCallback(
    (payload: boolean) => {
      alarmsDispatch({ type: AlarmsActionType.SetShowSystemAlarms, payload });
    },
    [alarmsDispatch]
  );

  const setFilterOptions = useCallback(
    (payload: AlarmsFilterOptionsModel) => {
      if (payload && payload.conditions) {
        alarmsDispatch({ type: AlarmsActionType.SetFilterOptions, payload });
      }
    },
    [alarmsDispatch]
  );

  return {
    alarmsState,
    setConditionFilter,
    setAcknowledgeFilter,
    setShowSystemAlarmsFilter,
    setFilterOptions,
  };
};
